// petite-vue-i18n almost same as vue-i18n, faster but with less features
// always can switch to vue-i18n if needed
import app from './app.js';
import { createI18n } from 'petite-vue-i18n'

// Manually import each locale filet
import en from './locales/en.json'
// Add more imports as needed for each locale

const i18n = createI18n({
  locale: process.env.VUE_APP_I18N_LOCALE || 'en',
  fallbackLocale: process.env.VUE_APP_I18N_FALLBACK_LOCALE || 'en',
  messages: {
    en,
    // Add more locales here
  },
})

app.use(i18n)
app.provide('i18n', i18n.global)

export default i18n;
